import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {Alert} from 'componentLibrary';
import ButtonField from 'app-ui-componentlibrary/dist/go/components/common/form/ButtonField';
import AorContactInfoModal from 'go/components/modules/amendments/AorContactInfoModal';
import SpanText from 'app-ui-componentlibrary/dist/go/components/common/form/SpanText';
import {Header, Form, Grid, Card, Button, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {
  getFirstErrorForField,
  phoneTypeProfileToContacts,
  displayObjectErrors,
} from 'common/utils';
import {produce} from 'immer';
import {ALWAYS_DIRTY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
export const PARTICIPANTS = 'participants';
export const POINT_OF_CONTACTS = 'pointOfContacts';
export const AOR = 'aor';

export const TYPE_MAPPING = {
  [PARTICIPANTS]: 'participants',
  [POINT_OF_CONTACTS]: 'point of contact',
  [AOR]: 'AOR',
};

export const ContactsList = (props) => {
  const {
    dataPath,
    contacts,
    handleDelete,
    showAdditionalPhones,
    deleteButtonMinSize,
    deleteFirstContact,
    isTitleRequired,
    validationErrors,
    readOnly,
  } = props;

  const canDeleteContact = (size, idx) => {
    if (size <= deleteButtonMinSize) return false;
    if (idx == 0 && !deleteFirstContact) return false;
    return true;
  };
  const getError = (fieldPath) => {
    return displayObjectErrors(validationErrors, ALWAYS_DIRTY_MAP, fieldPath);
  };

  let gridRows = [];

  let contact = contacts;

  gridRows = (
    <Grid.Row columns={3} padded={false}>
      <Grid.Column className="overFlowText" width={4}>
        <Grid width={16} columns={1} padded={false} stackable centered>
          <Grid.Row columns={1} padded={false}>
            <Grid.Column width={16} padded={false}>
              <Card.Header>
                <b>
                  {contact.prefix ? contact.prefix + ' ' : ''}
                  <SpanText
                    name={`${dataPath}.firstName`}
                    value={contact.firstName}
                    displayError={getError(['firstName']).displayError}
                    errorMessages={getError(['firstName']).errorMessages}
                  />
                  {contact.middleInitial ? ' ' + contact.middleInitial : ''}
                  <SpanText
                    name={`${dataPath}.lastName`}
                    value={contact.lastName ? ' ' + contact.lastName : ''}
                    displayError={getError(['lastName']).displayError}
                    errorMessages={getError(['lastName']).errorMessages}
                  />
                  {contact.suffix ? ' ' + contact.suffix : ''}
                </b>
              </Card.Header>
              <Card.Content>
                {isTitleRequired ? (
                  <SpanText
                    name={`${dataPath}.title`}
                    value={contact.title}
                    displayError={getError(['title']).displayError}
                    errorMessages={getError(['title']).errorMessages}
                  />
                ) : (
                  ''
                )}
              </Card.Content>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1} padded={false}>
            <Grid.Column width={16} padded={false}>
              <Card.Content>&nbsp;</Card.Content>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1} padded={false}>
            <Grid.Column width={16} padded={false}>
              <Card.Content>
                <SpanText
                  name={`${dataPath}.userId`}
                  value={contact.emailAdr ? contact.emailAdr : contact.userId}
                  isHyperlink={!getError(['userId']).displayError}
                  hyperlinkUrl={`mailto:${contact.emailAdr}`}
                  displayError={getError(['userId']).displayError}
                  errorMessages={getError(['userId']).errorMessages}
                />
              </Card.Content>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
      <Grid.Column width={10}>
        <Grid width={16} columns={3} padded={false} stackable centered>
          <Grid.Row columns={2} padded={false}>
            <Grid.Column width={8} padded={false}>
              {contact.phoneNumbers &&
              contact.phoneNumbers[0] &&
              contact.phoneNumbers.length > 0 ? (
                <div>
                  <Card.Header>
                    <b>Primary phone</b>
                  </Card.Header>
                  <Card.Content>
                    <SpanText
                      name={`${dataPath}.phoneNumbers[0]`}
                      value={
                        contact.phoneNumbers[0].areaCode &&
                        contact.phoneNumbers[0].phoneNumber
                          ? contact.phoneNumbers[0].areaCode +
                            contact.phoneNumbers[0].phoneNumber
                          : ''
                      }
                      displayError={getError(['phoneNumber']).displayError}
                      errorMessages={getError(['phoneNumber']).errorMessages}
                    />
                    {contact.phoneNumbers[0].phoneExtension
                      ? ' ext ' + contact.phoneNumbers[0].phoneExtension
                      : ''}
                  </Card.Content>
                  <Card.Content>
                    <SpanText
                      name={`${dataPath}.phoneNumbers[0]`}
                      value={
                        contact.phoneNumbers[0].phoneType
                          ? _.upperFirst(
                              phoneTypeProfileToContacts(
                                contact.phoneNumbers[0].phoneType
                              )
                            )
                          : ''
                      }
                      displayError={getError(['phoneNumberType']).displayError}
                      errorMessages={getError(['phoneNumberType']).errorMessages}
                    />
                  </Card.Content>
                </div>
              ) : (
                <div>
                  <Card.Header>
                    <b>Primary phone</b>
                  </Card.Header>
                  <Card.Content>&nbsp;</Card.Content>
                </div>
              )}
            </Grid.Column>
            <Grid.Column width={8} padded={false}>
              {showAdditionalPhones &&
              contact.phoneNumbers &&
              contact.phoneNumbers[1] &&
              contact.phoneNumbers.length > 1 ? (
                <div>
                  <Card.Header>
                    <b>Additional phones</b>
                  </Card.Header>
                  <Card.Content>
                    <SpanText
                      name={`${dataPath}.phoneNumbers[1]`}
                      value={
                        contact.phoneNumbers[1].areaCode &&
                        contact.phoneNumbers[1].phoneNumber
                          ? contact.phoneNumbers[1].areaCode +
                            contact.phoneNumbers[1].phoneNumber
                          : ''
                      }
                      displayError={getError(['phoneNumber']).displayError}
                      errorMessages={getError(['phoneNumber']).errorMessages}
                    />
                    {contact.phoneNumbers[1].phoneExtension
                      ? ' ext ' + contact.phoneNumbers[1].phoneExtension
                      : ''}
                  </Card.Content>
                  <Card.Content>
                    <SpanText
                      name={`${dataPath}.phoneNumbers[1]`}
                      value={
                        contact.phoneNumbers[1].phoneType
                          ? _.upperFirst(
                              phoneTypeProfileToContacts(
                                contact.phoneNumbers[1].phoneType
                              )
                            )
                          : ''
                      }
                      displayError={getError(['phoneNumberType']).displayError}
                      errorMessages={getError(['phoneNumberType']).errorMessages}
                    />
                  </Card.Content>
                </div>
              ) : (
                <div>
                  <Card.Header>
                    <b>Additional phones</b>
                  </Card.Header>
                  <Card.Content>&nbsp;</Card.Content>
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} padded={false}>
            <Grid.Column width={8}>
              <Card.Header>&nbsp;</Card.Header>
              {showAdditionalPhones &&
              contact.phoneNumbers &&
              contact.phoneNumbers[2] &&
              contact.phoneNumbers.length > 2 ? (
                <Card.Content>
                  {contact.phoneNumbers[2].areaCode && contact.phoneNumbers[2].phoneNumber
                    ? contact.phoneNumbers[2].areaCode +
                      contact.phoneNumbers[2].phoneNumber
                    : ''}
                  {contact.phoneNumbers[2].phoneExtension
                    ? ' ext ' + contact.phoneNumbers[2].phoneExtension
                    : ''}
                </Card.Content>
              ) : (
                ''
              )}
              {showAdditionalPhones && contact.phoneNumbers && contact.phoneNumbers[2] ? (
                <Card.Content>
                  {contact.phoneNumbers[2].phoneType
                    ? _.upperFirst(
                        phoneTypeProfileToContacts(contact.phoneNumbers[2].phoneType)
                      )
                    : ''}
                </Card.Content>
              ) : (
                ''
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
      {!readOnly && (
        <Grid.Column width={2}>
          <Grid width={16} columns={3} padded={false} stackable centered>
            <Grid.Row columns={1} padded={false}>
              <Grid.Column width={16} padded={false}>
                &nbsp;
              </Grid.Column>
              <Grid.Column width={16} padded={false}>
                &nbsp;
              </Grid.Column>
              {canDeleteContact(_.size(contacts)) ? (
                <Grid.Column width={16}>
                  <Button
                    id={contact.userId}
                    className="mini button"
                    labelPosition="left"
                    onClick={() => handleDelete()}
                  >
                    <Icon
                      className="fitted link"
                      id={contact.userId}
                      name="pencil"
                      size="small"
                      color="blue"
                    />
                    <font className="ui.blue.button.smallLabel">Delete</font>
                  </Button>
                </Grid.Column>
              ) : (
                <Grid.Column width={16} padded={false}>
                  &nbsp;
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Grid.Column>
      )}
    </Grid.Row>
  );
  return gridRows;
};

export class AorContactInformation extends React.Component {
  state = {
    contactInfoModalIsOpen: false,
    contactInfoModalType: '',
    contactInfoIndex: 0,
    contactInfoConfig: {},
    contactInfo: {},
  };

  componentDidMount() {
    if (!_.isEmpty(this.props.data)) {
      this.setState({contactInfo: this.props.data});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data && !_.isEqual(prevProps.data, this.props.data)) {
      this.setState({contactInfo: this.props.data});
    }
  }

  getContactConfig = (type) => {};

  createUser = (type) => {
    const {saveEntityData, entityDataPath, entityType, validationId} = this.props;
    const {contactInfo} = this.state;
    const numOfContacts = _.size(_.get(contactInfo, type));
    const config = _.get(this.props, type);
    this.setState({
      contactInfoModalIsOpen: true,
      contactInfoModalType: type,
      contactInfoIndex: numOfContacts,
      contactInfoConfig: config,
    });
  };

  handleDelete = (type) => {
    const {saveEntityData, validationId, entityDataPath, entityType} = this.props;
    const {contactInfo} = this.state;

    this.setState(
      {
        contactInfo: produce(contactInfo, (draft) => {
          _.set(draft, type, {});
          //_.get(draft, type, []).splice(index, 1);
        }),
      },
      () =>
        saveEntityData(entityDataPath, entityType, this.state.contactInfo, validationId)
    );
  };

  handleContactChoose = (contactType, contactIndex, updateContact, fieldPath) => {
    const {saveEntityData, validationId, entityDataPath, entityType} = this.props;

    if (contactType === AOR && _.isEmpty(updateContact.userId)) return;
    this.setState(
      {
        contactInfo: produce(this.state.contactInfo, (draft) => {
          _.set(draft, `${AOR}`, updateContact);
        }),
      },
      () =>
        saveEntityData(
          entityDataPath,
          entityType,
          this.state.contactInfo,
          `${validationId}.${fieldPath}`
        )
    );
  };

  getErrorsForType = (type) => {
    const {validationErrors} = this.props;
    return _.get(getFirstErrorForField(validationErrors, type), 'error');
  };

  render() {
    const {token} = this.props;
    const {
      entityDataPath,
      organizationId,
      programId,
      parentOrgId,
      readOnly,
      aors,
    } = this.props;

    let AOR = 'aor';
    const maxAors = aors && aors.max ? aors.max : 1;
    const disableAors = aors && aors.hidden;

    const addAorButton = !disableAors && {
      submitButtonLabel: 'Add an AOR',
      name: 'addAORButton',
      id: 'addAORButton',
      color: 'blue',
      handleClick: () => this.createUser(AOR),
    };

    const {contactInfo, contactInfoModalType, contactInfoIndex} = this.state;

    let matchingParticipant = _.get(contactInfo, contactInfoModalType);

    const aorErrors = this.getErrorsForType(AOR);

    const selectedContactErrors = _.get(
      this.getErrorsForType(contactInfoModalType),
      contactInfoIndex
    );

    return (
      <Form>
        <Grid
          key={'contactInformationGrid'}
          stackable
          reversed="mobile"
          padded="vertically"
        >
          <Grid.Column mobile={16} tablet={16} computer={16}>
            {!disableAors && (
              <React.Fragment>
                <br />
                <div>
                  <Header
                    as="h4"
                    content={_.get(
                      this.props.aors,
                      'header',
                      'Authorized Organization Representatives (AOR)'
                    )}
                    id="aorHeader"
                  />
                  <hr />
                  {_.get(this.props.aors, 'instructions.main', '') && (
                    <div className="textMedium">{this.props.aors.instructions.main}</div>
                  )}
                  {_.get(this.props.aors, 'instructions.additional') && (
                    <React.Fragment>
                      <br />
                      <div className="instructionsAdditional">
                        {this.props.aors.instructions.additional}
                      </div>
                    </React.Fragment>
                  )}
                  <br />
                  {!contactInfo.aor || _.isEmpty(contactInfo.aor) ? (
                    <Alert
                      type="error"
                      header="Add an authorized organization representative."
                      paragraph={false}
                    >
                      At least one authorized organization representative is required.
                    </Alert>
                  ) : (
                    <Grid width={16} columns={3} divided="vertically" celled>
                      <ContactsList
                        dataPath={`${entityDataPath}.${AOR}`}
                        contacts={contactInfo.aor}
                        handleDelete={() => this.handleDelete(AOR)}
                        deleteButtonMinSize={0}
                        deleteFirstContact={true}
                        showAdditionalPhones={true}
                        showFax={false}
                        showMailingAddress={false}
                        isTitleRequired={true}
                        validationErrors={aorErrors}
                        readOnly={readOnly}
                        disableEdit={true}
                      />
                    </Grid>
                  )}
                  {!readOnly &&
                    (maxAors < 0 || _.size(_.get(contactInfo, 'aor')) < maxAors) && (
                      <ButtonField
                        buttonText={addAorButton.submitButtonLabel}
                        name={addAorButton.name}
                        id={addAorButton.id}
                        handleClick={addAorButton.handleClick}
                        color={addAorButton.color}
                      />
                    )}
                </div>
              </React.Fragment>
            )}
            <AorContactInfoModal
              config={this.state.contactInfoConfig}
              contact={matchingParticipant}
              handleDelete={() => {
                this.handleDelete(
                  this.state.contactInfoModalType,
                  this.state.contactInfoIndex
                );
                this.setState({contactInfoModalIsOpen: false});
              }}
              handleChoose={(newContact) =>
                this.handleContactChoose(
                  this.state.contactInfoModalType,
                  this.state.contactInfoIndex,
                  newContact
                )
              }
              token={token}
              open={this.state.contactInfoModalIsOpen}
              type={this.state.contactInfoModalType}
              handleClose={() => {
                this.setState({contactInfoModalIsOpen: false});
              }}
              validationErrors={selectedContactErrors}
              organizationId={organizationId}
              programId={programId}
              parentOrgId={parentOrgId}
            />
          </Grid.Column>
        </Grid>
      </Form>
    );
  }
}

export default connectWithCore(AorContactInformation);
